import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import FeaturedProjects from "@/components/FeaturedProjects";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import About from "@/components/About";
import CtaBanner from "@/components/CtaBanner";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Portfolio() {
  return (
    <main className="relative min-h-screen bg-[#050505] text-white">
      <Header />
      <Hero />
      <Marquee />
      <FeaturedProjects />
      <CtaBanner />
      <Services />
      <Stats />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
